import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { Login } from "../pages/NotProtectedOnly/Login.jsx";
import { Route } from "react-router-dom";
import { GlobalErrorElement } from "../components/GlobalErrorElement.jsx";
import { ErrorBoundary } from "react-error-boundary";
import { Layout } from "../layouts/Layout.jsx";
import { Signup } from "@/pages/NotProtectedOnly/Signup.jsx";
import { OtpVerification } from "@/pages/NotProtectedOnly/OtpVerification.jsx";
import { ForgotPassword } from "@/pages/ForgetPassword/ForgetPassword.jsx";
import { ResetPassword } from "@/pages/ForgetPassword/ResetPassword.jsx";
import { Unauthorized } from "@/pages/Unauthorized.jsx";
import { ProtectedRoute, PaymentStatusMiddleware } from "@/layouts";
import Landing from "@/pages/Landing.jsx";
import WelcomeVideo from "@/pages/WelcomeVideo.jsx";
import InPersonBooking from "@/pages/InPersonBooking.jsx";
import Paywall from "@/pages/Paywall.jsx";
import BookingSuccess from "@/pages/BookingSuccess.jsx";
import InviteFriends from "@/pages/InviteFriends.jsx";
import InviteeQuestions from "@/pages/InviteeQuestions.jsx";
import ThankYouInvitee from "@/pages/ThankYouInvitee.jsx";
import { UserDashboard, Form } from "@/pages/User";
import TranscriptionDashboard from "@/pages/User/TranscriptionDashboard.jsx";
import InterviewerDashboard from "@/pages/InterviewerDashboard.jsx";
import { AdminDashboard } from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin.jsx";
import InterviewerLogin from "@/pages/InterviewerLogin.jsx";
import InviteRegistration from "@/pages/InviteRegistration.jsx";
import UserQuestions from "@/pages/Interviewer/UserQuestions.jsx";
import RemoteCallBooking from "@/pages/RemoteCallBooking.jsx";
import AssistedRecording from "@/pages/AssistedRecording.jsx";
import AuthInitializer from "@/components/AuthInitializer.jsx";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={
        <GlobalErrorElement
          error={new Error("Page Not Found")}
          resetErrorBoundary={() => {}}
        />
      }
    >
      {/* Error boundary and Layout */}
      <Route
        element={
          <ErrorBoundary FallbackComponent={GlobalErrorElement}>
            <AuthInitializer>
              <Layout />
            </AuthInitializer>
          </ErrorBoundary>
        }
      >
        {/* All routes */}
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="welcome-video" element={<WelcomeVideo />} />
        <Route path="in-person-booking" element={<InPersonBooking />} />
        <Route path="remote-call" element={<RemoteCallBooking />} />
        <Route path="assisted-recording" element={<AssistedRecording />} />
        <Route path="paywall" element={<Paywall />} />
        <Route path="booking-success" element={<BookingSuccess />} />
        <Route
          path="invite-questions/:inviteId?"
          element={<InviteeQuestions />}
        />
        <Route path="thank-you-invitee" element={<ThankYouInvitee />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="otp-verification" element={<OtpVerification />} />
        <Route path="unauthorized" element={<Unauthorized />} />
        <Route path="admin-login" element={<AdminLogin />} />
        <Route path="interviewer-login" element={<InterviewerLogin />} />
        <Route path="register/invite" element={<InviteRegistration />} />

        {/* Protected Routes with Payment Status Middleware */}
        <Route element={<ProtectedRoute />}>
          <Route element={<PaymentStatusMiddleware />}>
          <Route path="user-dashboard" element={<UserDashboard />} />
          <Route path="user-form" element={<Form />} />
          <Route path="user/transcription-dashboard" element={<TranscriptionDashboard />} />
          <Route path="invite-friends" element={<InviteFriends />} />
          <Route
            path="interviewer-dashboard"
            element={<InterviewerDashboard />}
          />
          <Route path="admin-dashboard" element={<AdminDashboard />} />
          <Route path="user-questions/:userId" element={<UserQuestions />} />
          </Route>
        </Route>
      </Route>
    </Route>
  )
);
